<template>
	<div>
		<iframe v-if="showPdf" id='previewContract' :src="url" height="920" width="100%"></iframe>
	</div>
</template>

<script>
	export default {
		name: 'contract-pdf-view',
		components: {
		},
		data() {
			return {
				showPdf: true,
				contractVisable: false,
				currentType: process.env.ENV_CONFIG,
				url: ''
			}
		},
		mounted() {
			let fileUrl = sessionStorage.getItem("pdfUrl")
			if (this.currentType == "dev") {
				this.url = '/static/pdf/web/viewer.html?file=' + fileUrl
			} else {
				this.url = process.env.PUBLIC_PATH + "static/pdf/web/viewer.html?file=" + fileUrl
			}
		}
	}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/contract/contract-pdf-view.vue